import React, { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ContentTemplate } from 'web-library';
import { WorkPassType } from '../../../../api-refactored/candidate/useGetWorkPassTypes';
import { UserCitizenShipsResponse } from '../../../../api-refactored/non-national-exam-registration/useGetUserCitizenShips';
import { CitizenType, docType, TypeParent } from './ParentParticularsAeisExam';
import ParticularParentDetail from './ParticularParentDetail';

interface IParentDetailForm {
  form: any;
  workPassTypes: WorkPassType[] | undefined;
  citizenShips: UserCitizenShipsResponse[] | undefined;
  formDefaultValues: any;
  classes: any;
  hasEditAccess: boolean;
}

const NOT_APPLICABLE = 'NOT APPLICABLE';

const useFormFatherLogic = (
  form: UseFormReturn<any>,
  workPassTypes: WorkPassType[] | undefined
) => {
  const [isDisableFatherDocType, setIsDisableFatherDocType] = useState<boolean>(true);
  const [isDisableFatherDocNo, setIsDisableFatherDocNo] = useState<boolean>(false);
  const [isDisableFatherWpt, setIsDisableFatherWpt] = useState<boolean>(false);
  const [isDisableFatherFin, setIsDisableFatherFin] = useState<boolean>(false);
  const [isHiddenFatherDocType, setIsHiddenFatherDocType] = useState<boolean>(false);
  const [isHiddenFatherDocNo, setIsHiddenFatherDocNo] = useState<boolean>(false);
  const { watch, setValue } = form;

  const {
    fatherCitizen: watchFatherCitizen,
    fatherDocType: watchFatherDocType,
    fatherWorkPassType: watchFatherWorkPassType,
  } = watch();

  const notApplicableWPT = workPassTypes?.find((v) => v.description === NOT_APPLICABLE);

  useEffect(() => {
    if (
      watchFatherCitizen?.code === CitizenType.PR ||
      watchFatherCitizen?.code === CitizenType.SC
    ) {
      setIsDisableFatherDocType(true);
      setIsDisableFatherDocNo(false);
      setIsDisableFatherWpt(true);
      setIsDisableFatherFin(true);
      setIsHiddenFatherDocType(false);
      setIsHiddenFatherDocNo(false);
      if (form.formState.isDirty) {
        setValue('fatherDocType', docType[0]);
        setValue('fatherDocNo', '');
        setValue('fatherWorkPassType', notApplicableWPT);
        setValue('fatherFin', '');
      }
    }

    if (watchFatherCitizen?.code === CitizenType.OTHERS) {
      setIsDisableFatherDocType(true);
      setIsDisableFatherDocNo(true);
      setIsHiddenFatherDocType(true);
      setIsHiddenFatherDocNo(true);
      setIsDisableFatherWpt(false);
      if (form.formState.isDirty) {
        setValue('fatherDocType', docType[2]);
        setValue('fatherDocNo', '');
        setValue('fatherWorkPassType', null);
        setValue('fatherFin', '');
      }
    }

    if (watchFatherCitizen?.code === CitizenType.NA) {
      setIsDisableFatherDocType(true);
      setIsDisableFatherDocNo(true);
      setIsDisableFatherWpt(true);
      setIsDisableFatherFin(true);
      setIsHiddenFatherDocType(false);
      setIsHiddenFatherDocNo(false);

      if (form.formState.isDirty) {
        setValue('fatherDocType', docType[2]);
        setValue('fatherWorkPassType', notApplicableWPT);
        setValue('fatherFin', '');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchFatherCitizen]);

  useEffect(() => {
    if (watchFatherDocType?.code === 'NOTAPPLICABLE') {
      if (form.formState.isDirty) {
        setValue('fatherDocNo', '');
        setValue(
          'fatherWorkPassType',
          watchFatherCitizen?.code === CitizenType.OTHERS ? null : notApplicableWPT
        );
        setValue('fatherFin', '');
      }
      setIsDisableFatherDocNo(true);
      setIsHiddenFatherDocType(false);
      setIsHiddenFatherDocNo(false);
      if (watchFatherCitizen?.code === CitizenType.OTHERS) {
        setIsHiddenFatherDocType(true);
        setIsHiddenFatherDocNo(true);
        setIsDisableFatherWpt(false);
        setIsDisableFatherFin(false);
      }
    }

    if (watchFatherDocType?.code === 'P') {
      if (form.formState.isDirty) {
        setValue('fatherDocNo', '');
        setValue('fatherWorkPassType', null);
        setValue('fatherFin', '');
      }
      setIsDisableFatherDocNo(false);
      setIsDisableFatherWpt(false);
      setIsDisableFatherFin(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchFatherDocType]);

  useEffect(() => {
    setIsDisableFatherFin(watchFatherWorkPassType?.description === NOT_APPLICABLE);
    if (form.formState.isDirty) {
      setValue('fatherFin', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchFatherWorkPassType]);

  return {
    isDisableFatherDocType,
    isDisableFatherDocNo,
    isDisableFatherWpt,
    isDisableFatherFin,
    isHiddenFatherDocType,
    isHiddenFatherDocNo,
  };
};

const useFormMotherLogic = (
  form: UseFormReturn<any>,
  workPassTypes: WorkPassType[] | undefined
) => {
  const [isDisableMotherDocType, setIsDisableMotherDocType] = useState<boolean>(true);
  const [isDisableMotherDocNo, setIsDisableMotherDocNo] = useState<boolean>(false);
  const [isDisableMotherWpt, setIsDisableMotherWpt] = useState<boolean>(false);
  const [isDisableMotherFin, setIsDisableMotherFin] = useState<boolean>(false);
  const [isHiddenMotherDocType, setIsHiddenMotherDocType] = useState<boolean>(false);
  const [isHiddenMotherDocNo, setIsHiddenMotherDocNo] = useState<boolean>(false);

  const { watch, setValue } = form;
  const {
    motherCitizen: watchMotherCitizen,
    motherDocType: watchMotherDocType,
    motherWorkPassType: watchMotherWorkPassType,
  } = watch();

  const notApplicableWPT = workPassTypes?.find((v) => v.description === NOT_APPLICABLE);

  useEffect(() => {
    if (
      watchMotherCitizen?.code === CitizenType.PR ||
      watchMotherCitizen?.code === CitizenType.SC
    ) {
      setIsDisableMotherDocType(true);
      setIsDisableMotherDocNo(false);
      setIsDisableMotherWpt(true);
      setIsDisableMotherFin(true);
      setIsHiddenMotherDocType(false);
      setIsHiddenMotherDocNo(false);
      if (form.formState.isDirty) {
        setValue('motherDocType', docType[0]);
        setValue('motherDocNo', '');
        setValue('motherWorkPassType', notApplicableWPT);
        setValue('motherFin', '');
      }
    }

    if (watchMotherCitizen?.code === CitizenType.OTHERS) {
      setIsDisableMotherDocType(true);
      setIsDisableMotherDocNo(true);
      setIsHiddenMotherDocType(true);
      setIsHiddenMotherDocNo(true);
      setIsDisableMotherWpt(false);
      if (form.formState.isDirty) {
        setValue('motherDocType', docType[2]);
        setValue('motherDocNo', '');
        setValue('motherWorkPassType', null);
        setValue('motherFin', '');
      }
    }

    if (watchMotherCitizen?.code === CitizenType.NA) {
      setIsDisableMotherDocType(true);
      setIsDisableMotherDocNo(true);
      setIsDisableMotherWpt(true);
      setIsDisableMotherFin(true);
      setIsHiddenMotherDocType(false);
      setIsHiddenMotherDocNo(false);

      if (form.formState.isDirty) {
        setValue('motherDocType', docType[2]);
        setValue('motherWorkPassType', notApplicableWPT);
        setValue('motherFin', '');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchMotherCitizen]);

  useEffect(() => {
    if (watchMotherDocType?.code === 'NOTAPPLICABLE') {
      if (form.formState.isDirty) {
        setValue('motherDocNo', '');
        setValue(
          'motherWorkPassType',
          watchMotherCitizen?.code === CitizenType.OTHERS ? null : notApplicableWPT
        );
        setValue('motherFin', '');
      }
      setIsDisableMotherDocNo(true);
      setIsHiddenMotherDocType(false);
      setIsHiddenMotherDocNo(false);
      if (watchMotherCitizen?.code === CitizenType.OTHERS) {
        setIsHiddenMotherDocType(true);
        setIsHiddenMotherDocNo(true);
        setIsDisableMotherWpt(false);
        setIsDisableMotherFin(false);
      }
    }

    if (watchMotherDocType?.code === 'P') {
      if (form.formState.isDirty) {
        setValue('motherDocNo', '');
        setValue('motherWorkPassType', null);
        setValue('motherFin', '');
      }
      setIsDisableMotherDocNo(false);
      setIsDisableMotherWpt(false);
      setIsDisableMotherFin(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchMotherDocType]);

  useEffect(() => {
    setIsDisableMotherFin(watchMotherWorkPassType?.description === NOT_APPLICABLE);
    if (form.formState.isDirty) {
      setValue('motherFin', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchMotherWorkPassType]);

  return {
    isDisableMotherDocType,
    isDisableMotherDocNo,
    isDisableMotherWpt,
    isDisableMotherFin,
    isHiddenMotherDocType,
    isHiddenMotherDocNo,
  };
};

const ParentDetailForm = ({
  form,
  workPassTypes,
  citizenShips,
  formDefaultValues,
  classes,
  hasEditAccess,
}: IParentDetailForm) => {
  const { t } = useTranslation();
  const {
    formState: { errors },
    watch,
  } = form;

  const watchParentType = watch('parentType');

  const {
    isDisableFatherDocNo,
    isDisableFatherDocType,
    isDisableFatherFin,
    isDisableFatherWpt,
    isHiddenFatherDocType,
    isHiddenFatherDocNo,
  } = useFormFatherLogic(form, workPassTypes);

  const {
    isDisableMotherDocNo,
    isDisableMotherDocType,
    isDisableMotherFin,
    isDisableMotherWpt,
    isHiddenMotherDocType,
    isHiddenMotherDocNo,
  } = useFormMotherLogic(form, workPassTypes);

  useEffect(
    () => {
      if (formDefaultValues) {
        form.reset(formDefaultValues);
      }
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [formDefaultValues]
  );
  return (
    <>
      {(watchParentType?.code === TypeParent.MotherAndFather ||
        watchParentType?.code === TypeParent.Father) && (
        <ContentTemplate continuous isContinuable>
          <ParticularParentDetail
            title={t('exam->>ParentParticulars.fatherDetails')}
            classes={classes}
            nameErr={!!errors?.fatherName}
            nameErrMsg={errors?.fatherName?.message}
            labelName="fatherName"
            labelCitizen="fatherCitizen"
            labelDocType="fatherDocType"
            labelWorkPassType="fatherWorkPassType"
            labelDocNo="fatherDocNo"
            labelFin="fatherFin"
            dataCitizen={citizenShips}
            docNoErr={!!errors?.fatherDocNo}
            docNoErrMsg={errors?.fatherDocNo?.message}
            citizenErr={!!errors?.fatherCitizen}
            citizenErrMsg={errors?.fatherCitizen?.message}
            docTypeErr={!!errors?.fatherDocType}
            docTypeErrMsg={errors?.fatherDocType?.message}
            dataDocType={docType}
            dataWorkPassType={workPassTypes}
            workPassTypeErr={!!errors?.fatherWorkPassType}
            workPassTypeErrMsg={errors?.fatherWorkPassType?.message}
            finErr={!!errors?.fatherFin}
            finErrMsg={errors?.fatherFin?.message}
            formHook={form}
            hasEditAccess={hasEditAccess}
            isDisableDocType={isDisableFatherDocType}
            isDisableDocNo={isDisableFatherDocNo}
            isDisableWpt={isDisableFatherWpt}
            isDisableFin={isDisableFatherFin}
            isHiddenDocType={isHiddenFatherDocType}
            isHiddenDocNo={isHiddenFatherDocNo}
          />
        </ContentTemplate>
      )}
      {(watchParentType?.code === TypeParent.MotherAndFather ||
        watchParentType?.code === TypeParent.Mother) && (
        <ContentTemplate
          continuous
          isContinuable
          isDividerTop={watchParentType?.code === TypeParent.MotherAndFather}
        >
          <ParticularParentDetail
            title={t('exam->>ParentParticulars.motherDetails')}
            classes={classes}
            nameErr={!!errors?.motherName}
            nameErrMsg={errors?.motherName?.message}
            labelName="motherName"
            labelCitizen="motherCitizen"
            labelDocType="motherDocType"
            labelWorkPassType="motherWorkPassType"
            labelDocNo="motherDocNo"
            labelFin="motherFin"
            dataCitizen={citizenShips}
            citizenErr={!!errors?.motherCitizen}
            citizenErrMsg={errors?.motherCitizen?.message}
            docTypeErr={!!errors?.motherDocType}
            docTypeErrMsg={errors?.motherDocType?.message}
            dataDocType={docType}
            dataWorkPassType={workPassTypes}
            workPassTypeErr={!!errors?.motherWorkPassType}
            workPassTypeErrMsg={errors?.motherWorkPassType?.message}
            finErr={!!errors?.motherFin}
            finErrMsg={errors?.motherFin?.message}
            docNoErr={!!errors?.motherDocNo}
            docNoErrMsg={errors?.motherDocNo?.message}
            formHook={form}
            hasEditAccess={hasEditAccess}
            isDisableDocType={isDisableMotherDocType}
            isDisableDocNo={isDisableMotherDocNo}
            isDisableWpt={isDisableMotherWpt}
            isDisableFin={isDisableMotherFin}
            isHiddenDocType={isHiddenMotherDocType}
            isHiddenDocNo={isHiddenMotherDocNo}
          />
        </ContentTemplate>
      )}
    </>
  );
};

export default ParentDetailForm;
